// import React from 'react'
// import { motion } from 'framer-motion';

// const Skills = () => {
//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1, transition: { duration: 0.5 } }}
//       className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
//     >
//       <div className="w-full lgl:w-1/2">
//         <div className="py-12 font-titleFont flex flex-col gap-4">
//           <p className="text-sm text-designColor tracking-[4px] uppercase">
//             Tech Stack
//           </p>
//           <h2 className="text-3xl md:text-4xl font-bold">Development Skill</h2>
//         </div>
//         <div className='className="mt-14 w-full flex flex-col gap-6'>
//           <div className="overflow-x-hidden">
//             <p className="text-sm uppercase font-medium">C++</p>
//             <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
//               <motion.span
//                 initial={{ x: "-100%", opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.5, delay: 0.5 }}
//                 className="w-[85%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
//               >
//                 <span className="absolute -top-7 right-0">85%</span>
//               </motion.span>
//             </span>
//           </div>
//           <div className="overflow-x-hidden">
//             <p className="text-sm uppercase font-medium">Python</p>
//             <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
//               <motion.span
//                 initial={{ x: "-100%", opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.5, delay: 0.5 }}
//                 className="w-[85%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
//               >
//                 <span className="absolute -top-7 right-0">85%</span>
//               </motion.span>
//             </span>
//           </div>
//           <div className="overflow-x-hidden">
//             <p className="text-sm uppercase font-medium">Html,Css,Js,Bootstrap</p>
//             <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
//               <motion.span
//                 initial={{ x: "-100%", opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.5, delay: 0.5 }}
//                 className="w-[90%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
//               >
//                 <span className="absolute -top-7 right-0">90%</span>
//               </motion.span>
//             </span>
//           </div>
//           <div className="overflow-x-hidden">
//             <p className="text-sm uppercase font-medium">Mongodb & (SQL | NOSQL)</p>
//             <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
//               <motion.span
//                 initial={{ x: "-100%", opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.5, delay: 0.5 }}
//                 className="w-[80%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
//               >
//                 <span className="absolute -top-7 right-0">80%</span>
//               </motion.span>
//             </span>
//           </div>
//           <div className="overflow-x-hidden">
//             <p className="text-sm uppercase font-medium">Express</p>
//             <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
//               <motion.span
//                 initial={{ x: "-100%", opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.5, delay: 0.5 }}
//                 className="w-[80%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
//               >
//                 <span className="absolute -top-7 right-0">80%</span>
//               </motion.span>
//             </span>
//           </div>
//         </div>
//       </div>

//       <div className="w-full lgl:w-1/2">
//         <div className="py-12 font-titleFont flex flex-col gap-4">
//           <p className="text-sm text-designColor tracking-[4px] uppercase">
//             Tech Stack
//           </p>
//           <h2 className="text-3xl md:text-4xl font-bold">Development Skill</h2>
//         </div>
//         <div className="flex flex-col gap-6">
//           <div className="overflow-x-hidden">
//             <p className="text-sm uppercase font-medium">React</p>
//             <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
//               <motion.span
//                 initial={{ x: "-100%", opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.5, delay: 0.5 }}
//                 className="w-[80%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
//               >
//                 <span className="absolute -top-7 right-0">80%</span>
//               </motion.span>
//             </span>
//           </div>
//           <div className="overflow-x-hidden">
//             <p className="text-sm uppercase font-medium">Node</p>
//             <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
//               <motion.span
//                 initial={{ x: "-100%", opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.5, delay: 0.5 }}
//                 className="w-[80%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
//               >
//                 <span className="absolute -top-7 right-0">80%</span>
//               </motion.span>
//             </span>
//           </div>
//           <div className="overflow-x-hidden">
//             <p className="text-sm uppercase font-medium">Git & Github</p>
//             <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
//               <motion.span
//                 initial={{ x: "-100%", opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.5, delay: 0.5 }}
//                 className="w-[90%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
//               >
//                 <span className="absolute -top-7 right-0">90%</span>
//               </motion.span>
//             </span>
//           </div>
//           <div className="overflow-x-hidden">
//             <p className="text-sm uppercase font-medium">Google OAuth, Cookies, Passport,Postman API,OpenCV)</p>
//             <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
//               <motion.span
//                 initial={{ x: "-100%", opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.5, delay: 0.5 }}
//                 className="w-[80%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
//               >
//                 <span className="absolute -top-7 right-0">80%</span>
//               </motion.span>
//             </span>
//           </div>
//           <div className="overflow-x-hidden">
//             <p className="text-sm uppercase font-medium">Web Scrapping using (Selenium|Beautifulsoup)</p>
//             <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
//               <motion.span
//                 initial={{ x: "-100%", opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.5, delay: 0.5 }}
//                 className="w-[100%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative"
//               >
//                 <span className="absolute -top-7 right-0">100%</span>
//               </motion.span>
//             </span>
//           </div>
//         </div>
//       </div>
//     </motion.div>
//   );
// }

// export default Skills

/* eslint-disable no-unused-vars */
import React from "react";
import {
  FaHtml5,
  FaCss3Alt,
  FaBootstrap,
  FaJsSquare,
  FaReact,
  FaNodeJs,
  FaGithubSquare,
} from "react-icons/fa";
import {
  SiMongodb,
  SiExpress,
  SiTailwindcss,
  SiFirebase,
  SiNextdotjs,
} from "react-icons/si";

const Skills = () => {
  return (
    <section className="pt-20 ">
      <div className="grid grid-cols-1 text-center md:grid-cols-3 xl:grid-cols-5 gap-6 xl:gap-10">
        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div>
            <FaHtml5 className="text-7xl inline" />
            <p className="block">HTML5</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div>
            <FaCss3Alt className="text-7xl" />
            <p className="block">Css3</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div>
            <FaBootstrap className="text-7xl inline" />
            <p className="block">Bootstrap</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div className="text-center">
            <SiTailwindcss className="text-7xl inline" />
            <p className="block">Tailwindcss</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div className="text-center">
            <FaJsSquare className="text-7xl inline" />
            <p className="block">JS</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div className="text-center">
            <FaReact className="text-7xl inline" />
            <p className="block">React</p>
          </div>
        </div>

        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div>
            <SiFirebase className="text-7xl inline" />
            <p className="block">FIrebase</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div>
            <FaNodeJs className="text-7xl" />
            <p className="block">Node Js</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div>
            <SiExpress className="text-7xl inline" />
            <p className="block">Express Js</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div className="text-center">
            <SiMongodb className="text-7xl inline" />
            <p className="block">Mongo DB</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div className="text-center">
            <FaGithubSquare className="text-7xl inline" />
            <p className="block">Github</p>
          </div>
        </div>
        <div className="bannerIcon w-auto lg:w-40 h-40" data-aos="zoom-in-up">
          <div className="text-center">
            <SiNextdotjs className="text-7xl inline" />
            <p className="block">Next Js</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
